import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class InputSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'input');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', ['main', 'content']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
            this.backgroundColorField('background.color', ['content']),
            this.borderColorField('border.color', ['main', 'content'], ['content']),
            this.sizeNumberField('border.radius', 'px'),

            this.backgroundColorField('active.background.color', ['input', 'content'], this.preset('active-background-color', 'main')),
            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.fontColorComboField('hover.font.color', ['main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['input', 'content'], this.preset('hover-background-color', 'main')),

        ];
    }

}
